// PasswordSection.jsx
import "../../../../../design/passwordSection.css";
import { useState } from "react";
import api from "../../../../../api/API_SERVERS";
import { FaShieldHalved, FaLock } from "react-icons/fa6";

export default function PasswordSection({ showToast }) {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordRules, setPasswordRules] = useState({});
    const [passwordStrength, setPasswordStrength] = useState("");
    const [updating, setUpdating] = useState(false);

    const validatePassword = (pass, confirm) => ({
        length: pass.length >= 8,
        lowercase: /[a-z]/.test(pass),
        uppercase: /[A-Z]/.test(pass),
        number: /[0-9]/.test(pass),
        special: /[!@#$%^&*]/.test(pass),
        isMatch: pass === confirm && pass !== ""
    });

    const getStrength = (rules) => {
        const passed = Object.values(rules).filter(Boolean).length;
        if (passed <= 2) return "weak";
        if (passed <= 4) return "medium";
        return "strong";
    };

    const handlePasswordChange = (type, val) => {
        if (type === "old") setOldPassword(val);
        if (type === "new") {
            setNewPassword(val);
            const rules = validatePassword(val, confirmPassword);
            setPasswordRules(rules);
            setPasswordStrength(getStrength(rules));
        }
        if (type === "confirm") {
            setConfirmPassword(val);
            const rules = validatePassword(newPassword, val);
            setPasswordRules(rules);
            setPasswordStrength(getStrength(rules));
        }
    };

    const handleUpdate = async () => {
        const rules = validatePassword(newPassword, confirmPassword);
        if (!oldPassword) return showToast("შეიყვანეთ ძველი პაროლი!");
        if (!Object.values(rules).every(Boolean)) return showToast("ახალი პაროლი არასწორია!");

        try {
            setUpdating(true);
            await api.put("/api/teachers/profile/update-password", { oldPassword, newPassword });
            showToast("პაროლი განახლდა ✅", "success");
            setOldPassword(""); setNewPassword(""); setConfirmPassword("");
            setPasswordRules({}); setPasswordStrength("");
        } catch (error) {
            showToast(error.response?.data?.message || "შეცდომა ❌");
        } finally { setUpdating(false); }
    };

    return (
        <div className="password-glass-panel">
            <div className="panel-header">
                <FaLock className="header-icon" />
                <h3>პაროლის შეცვლა</h3>
            </div>

            <div className="password-form">
                <div className="glass-input-group">
                    <label>ძველი პაროლი</label>
                    <input type="password" value={oldPassword} onChange={(e) => handlePasswordChange("old", e.target.value)} />
                </div>

                <div className="glass-input-group">
                    <label>ახალი პაროლი</label>
                    <input type="password" value={newPassword} onChange={(e) => handlePasswordChange("new", e.target.value)} />
                    <div className="strength-container">
                        <div className={`strength-meter-bar ${passwordStrength}`}></div>
                    </div>
                </div>

                <div className="glass-input-group">
                    <label>გაიმეორეთ ახალი პაროლი</label>
                    <input type="password" value={confirmPassword} onChange={(e) => handlePasswordChange("confirm", e.target.value)} />
                </div>

                <div className="rules-grid">
                    {Object.entries({
                        "8+ სიმბოლო": passwordRules.length,
                        "დიდი ასო": passwordRules.uppercase,
                        "ციფრი": passwordRules.number,
                        "სიმბოლო": passwordRules.special,
                        "ემთხვევა": passwordRules.isMatch
                    }).map(([label, ok], i) => (
                        <div key={i} className={`rule-item ${ok ? "ok" : ""}`}>
                            <span className="dot"></span> {label}
                        </div>
                    ))}
                </div>

                <button className={`update-pass-btn ${updating ? "loading" : ""}`} onClick={handleUpdate} disabled={updating}>
                    <FaShieldHalved /> {updating ? "ინახება..." : "პაროლის განახლება"}
                </button>
            </div>
        </div>
    );
}